import { Config } from '@leverege/plugin';
import { MapControl } from '@leverege/ui-mapbox-elements';
import I18N from '@leverege/i18n';
import GeoUtil from "../../dataViewers/map/shared/GeoUtil.js";
const {
  t,
  tf,
  tIcon
} = I18N.ns('molten.imagine.map.centerOnItems');
export default {
  id: 'userPosition.action.centerOnItems',
  type: 'map.centerOnItems',
  name: tf('name'),
  matches: [{
    use: Config.get('MapScreen', 'centerUserActionBar', 'topLeftActionBar'),
    client: ['MapDataViewer', 'GoogleMapsDataViewer']
  }],
  layout: {
    // group : [ 'centerOn' ],
    // groupNames : [ 'Center On' ],
    // groupIcons : [ 'https://storage.googleapis.com/molten-ui-assets/icon-center-objects.png' ],
    sort: 'zzzz.z'
    // sectionName : 'Center On'
  },
  // handles clicks on unoccupied map space
  handles: context => {
    const {
      streetView
    } = context;
    return !streetView;
  },
  appearance: () => ({
    name: t('name'),
    icon: Config.get('MapScreen', 'centerItemsIcon', tIcon('centerItemsIcon', 'https://storage.googleapis.com/molten-ui-assets/icon-center-objects.png'))
  }),
  perform: ({
    context
  }) => {
    const {
      clientProps,
      mapViewer
    } = context;
    const {
      mapName,
      paginator
    } = clientProps;
    const {
      bounds,
      point
    } = GeoUtil.getBoundsOrPointFromItems(paginator.pageItems);
    if (bounds) {
      MapControl.flyToBounds(mapName, bounds, {
        padding: 60
      });
    } else if (point) {
      const zoom = mapViewer.map?.getZoom() < 16.1 ? 18 : mapViewer.map?.getZoom();
      MapControl.flyTo(mapName, {
        ...point,
        zoom
      });
    }
  }
};